import { html, LitElement } from 'lit-element';
import { kwCardEventStyles } from './kw-card-event-styles';

export class KwCardEvent extends LitElement {
  static get is() {
    return 'kw-card-event';
  }

  static get styles() {
    return [kwCardEventStyles];
  }

  static get properties() {
    return {
      /**
       * Size of the cards to be displayed by default is medium
       * @property
       * @type {small|medium|large}
       */
      sizeCard: {
        type: String,
        attribute: 'size-card',
      },

      /**
       * Object with the properties to be displayed
       * @property
       * @type {Object}
       */
      event: {
        type: Object,
      },
      /**
       * URL of the image which depends on the capacity
       * @property
       * @type {String}
       */
      imgGout: {
        type: String,
      },
      /**
       * Boolean that determines if one of the elements of the collapsible is open.
       * @property
       * @type {Boolean}
      */
      open: { type: Boolean, reflect: true },
      /**
       * Is a string of the element selected.
      * @property
      * @type {String}
      */
      id: { type: String },
    };
  }

  constructor() {
    super();
    this.event = {
      img: '',
      title: '',
      subtitle: '',
      description: '',
      startDate: '',
      lengthEvent: '',
      speaker: '',
      type: '',
      capacity: '',
    };
    this.open = false;
    this.id = '';
    this.sizeCard = 'medium';
  }

  connectedCallback() {
    super.connectedCallback();
  }

  getTemplateDate() {
    const dayNumber = this.event.startDate.day;
    const lengthEventNumber = parseInt(this.event.lengthEvent, 10);
    const endDayEvent = dayNumber + (lengthEventNumber - 1);

    if (lengthEventNumber > 2) {
      return html` <span>${dayNumber} - ${endDayEvent} ${this.event.startDate.month}</span>`;
    }
    if (lengthEventNumber > 1) {
      return html` <span>${dayNumber}, ${endDayEvent} ${this.event.startDate.month}</span>`;
    }
    return html` <span>${dayNumber} ${this.event.startDate.month}</span>`;
  }

  renderLargeCard() {
    return html`
    <div class="kw-card-event  kw-card-event__item--${this.sizeCard} ${this.event.eventDate}">
      ${this.event.imgLarge && html`
        <div class="kw-card-event__container-img--${this.sizeCard}">
          <img
            src="${this.event.imgLarge}"
            class="kw-card-event__img--${this.sizeCard} ${this.event.capacity}"
            alt="event image ${this.event.title}"
          />
          <img
          class="kw-card-event__img-gout--${this.sizeCard}"
          src="${this.imgGout}"
          alt="${this.event.capacity} icon"
          />
        </div>
      `}
      <div class="kw-card-event__container-data--${this.sizeCard}">
        <div class="kw-card-event__container-info--${this.sizeCard}">
        ${this.event.urlLink ? html`
          <a class="kw-card-event__link-title" href="${this.event.urlLink}" target="_blank" rel="noreferrer noopener">
            <h3 class="kw-card-event__title--${this.sizeCard}">
              ${this.event.subtitle ? html`${this.event.title} | ${this.event.subtitle}` : html`${this.event.title}`}</h3>
          </a>
        ` : html`
            <h3 class="kw-card-event__title--${this.sizeCard}">
              ${this.event.subtitle ? html`${this.event.title} | ${this.event.subtitle}` : html`${this.event.title}`}</h3>
        `}
          <div class="kw-card-event__container-info-left--${this.sizeCard}">
            <div>
              <div>
                <span>${this.event.speaker}</span>
              </div>
              <div>
                <span class="font__weight--900">${this.event.type}</span>
              </div>
            </div>
            <div class="text__align--end kw-card-event__container-date--${this.sizeCard}">
              <div class="font__weight--900">
              ${this.getTemplateDate()}
              </div>
              <div>
                <span>${this.event.eventPast ? 'Ya realizado' : html`${this.event.startDate.time}`}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="kw-card-event__container-description--${this.sizeCard}">
            <p>${this.event.description}</p>
            ${this.event.urlLink && this.event.textLink ? html`
              <a class="kw-card-event__container-link--${this.sizeCard}"
                aria-label="${this.event.ariaLabel}"
                target="_blank"
                href= "${this.event.urlLink}"
                rel="noopener noreferrer"
                  >${this.event.textLink}</a>
            ` : ''}
            
        </div>
  
        </div>
    </div>
  `;
  }

  renderMediumCard() {
    return html`
  <div class="kw-card-event kw-card-event__item-container--${this.sizeCard} ${this.event.capacity} ${this.event.eventDate}">
    ${this.event.imgMedium
      && html`
      <div class="kw-card-event__container-img--${this.sizeCard}">
        <img
          src="${this.event.imgMedium}"
          class="kw-card-event__img--${this.sizeCard}"
          alt="event image ${this.event.title}"
        />
          ${!this.event.defaultImg ? html`<img
          class="kw-card-event__img-gout--${this.sizeCard}"
          src="${this.imgGout}"
          alt="${this.event.capacity} icon"
          />
        </div>` : ''}
      </div>
    `}
    <div>
      <div class="kw-card-event__container-data--${this.sizeCard}">
        <div class="kw-card-event__container-info-left--${this.sizeCard}">
        ${this.event.urlLink ? html`
          <a class="kw-card-event__link-title" href="${this.event.urlLink}" target="_blank" rel="noreferrer noopener">
            <h3 class="kw-card-event__title--${this.sizeCard}">
              ${this.event.subtitle ? html`${this.event.title} | ${this.event.subtitle}` : html`${this.event.title}`}</h3>
          </a>
        ` : html`
          <h3 class="kw-card-event__title--${this.sizeCard}">
            ${this.event.subtitle ? html`${this.event.title} | ${this.event.subtitle}` : html`${this.event.title}`}</h3>
        `}
          <div class="kw-card-event__subtitle--${this.sizeCard}">
            <span>${this.event.speaker}</span>
            <div class="kw-card-event__separator--${this.sizeCard}"></div>
            <span>${this.event.type}</span>
          </div>
        </div>
        <div class="kw-card-event__container-date--${this.sizeCard} text__align--end">
        <div>
          <div >
          <div>
          ${this.getTemplateDate()}
        </div>
          </div>
          <div>
            <span>${this.event.eventPast ? 'Ya realizado' : html`${this.event.startDate.time}`}</span>
          </div>
        </div>
            <div>
            <button
              type="button" class="kw-card-event__container-button--${this.sizeCard} ${!this.open ? 'up-arrow-icon' : 'down-arrow-icon'}"
             @click="${this.toogleItemCard}"
              aria-label="Desplegar más información"
            ></button>
            </div>
        </div>
      </div>
          ${this.event.description ? html` 
              <div class="kw-card-event__container-description--${this.sizeCard}"  ?hidden="${!this.open}">
                <p>${this.event.description}</p>
                  ${this.event.urlLink ? html`
                    <a 
                    class="kw-card-event__container-link--${this.sizeCard}"
                    aria-label="${this.event.ariaLabel}"
                    target="_blank"
                    href= "${this.event.urlLink}"
                    rel="noopener noreferrer"
                      >+info</a>` : ''}
              </div>` : ''}
      </div>
    </div>
  `;
  }

  renderSmallCard() {
    return html`
      <div class="kw-card-event kw-card-event__container-item--${this.sizeCard} ${this.event.eventDate} ${this.event.capacity}">
        <div class="kw-card-event__item--${this.sizeCard}">
          <div class="kw-card-event__continer-title">
            ${this.event.urlLink ? html`
            <a class="kw-card-event__link-title" href="${this.event.urlLink}" target="_blank" rel="noreferrer noopener">
              <h3 class="kw-card-event__title--${this.sizeCard}">
                ${this.event.title}
              </h3>
            </a>` : html`
              <h3 class="kw-card-event__title--${this.sizeCard}">
                ${this.event.title}
              </h3>`}
              ${this.event.subtitle ? html` 
                <h3 class="kw-card-event__subtitle--${this.sizeCard}">
                  ${this.event.subtitle}
                </h3>
              ` : ''}
            <span class="kw-card-event__speaker--${this.sizeCard} font__weight--900">${this.event.speaker}</span>
          </div>
          <div class="kw-card-event__container-date--${this.sizeCard}">
            <div>
            ${this.getTemplateDate()}
            </div>
            <span class="kw-card-event__type">${this.event.type}</span>
          </div>
        </div> 
        <div class="kw-card-event__container-img">
            <img
              src="${this.imgGout}"
              alt="${this.event.capacity} icon"
            />
          </div>
      </div>
    `;
  }

  render() {
    return html`
      ${this.sizeCard === 'large' ? this.renderLargeCard() : ''}
      ${this.sizeCard === 'medium' ? this.renderMediumCard() : ''}
      ${this.sizeCard === 'small' ? this.renderSmallCard() : ''}
    `;
  }

  /* Handle toggle medium card in mobile version */
  toogleItemCard() {
    this.open = !this.open;
    this.dispatchOpen({ id: this.id, open: this.open });
  }

  dispatchOpen(detail) {
    const event = new CustomEvent('item:open', {
      detail,
      bubbles: true,
      composed: true,
    });
    this.dispatchEvent(event);
  }
}
